export default __webpack_public_path__ + "6d82d0e16b4c1bb04f610e19e8584942.png";